(ns iris.analytics.views
  (:require
   [re-frame.core :as re-frame]
   [iris.subs :as subs]
   [iris.events :as events]
   [iris.analytics.subs :as analytics-subs]
   [iris.analytics.events :as analytics-events]
   [iris.common :as common]
  ;;  [iris.styles.general]
   [clojure.string :as string]
   [cemerick.url :as cemerick.url]
   [iris.globals :as globals]
   [iris.styles.analytics :as $analytics]
  ;;  [iris.styles.general :as $general]
  ;;  [herb.core :refer [<class <id]]
   [iris.analytics.views.page-views :refer [page-views-report]]))


(defn load-reports
  ([] (let [report @(re-frame/subscribe [::analytics-subs/report])
            ;; ws @(re-frame/subscribe [::analytics-subs/ws])
            ws @(re-frame/subscribe [::subs/ws])]
        (cond (= report "archive")
              (do
                (re-frame/dispatch [::analytics-events/get-analytics-tables ws])
                (re-frame/dispatch [::analytics-events/get-total-report ws]))
              :else
              (do
                (re-frame/dispatch [::analytics-events/get-analytics-report report ws])
                (re-frame/dispatch [::analytics-events/get-total-report ws])))))
  ([e] (.preventDefault e)
       (load-reports)))


(defn set-report [e report]
  (.preventDefault e)
  (re-frame/dispatch [::analytics-events/set-report report]))


;; (defn on-click-admin [e d]
;;   (.preventDefault e)
;;   (println d)
;;   (println (:path (cemerick.url/url (:PageLocation d))))

;;   (let [ws @(re-frame/subscribe [::analytics-subs/ws])
;;         path (cond (:PageLocation d)
;;                    (:path (cemerick.url/url (:PageLocation d)))
;;                    (:RkBoard d)
;;                    (str "/" (:RkBoard d)))
;;         route-str (str js/window.location.origin path "?ws=" ws)
;;         ;; route-str (str js/window.location.origin "/acme.TLO")
;;         ]
;;     (println "route-str:" route-str)
;;     (re-frame/dispatch [::events/route-to route-str])
;;     )
;;   )


;; consider different options
;; ws needs to be put in upper level
;; maybe switch ws and then redirect will automatically happen
;; use page_type - thread, company, store, etc are little more problematic

(defn get-admin-url [d]
  (let [
        ;; ws @(re-frame/subscribe [::analytics-subs/ws])
        ws @(re-frame/subscribe [::subs/ws])
        path (cond (:PageLocation d)
                  ;;  (:path (cemerick.url/url (:PageLocation d)))
                   (str (:path (cemerick.url/url (:PageLocation d)))
                        ;; add ".WS" when NOT ends with / (home) or contains /t/ (thread)
                        (when (nil? (re-find #"/$|/t/" (:PageLocation d))) (str "." ws)))
                   (:RkBoard d)
                   (str "/" (:RkBoard d) "." ws))
        ;; route-str (str js/window.location.origin path "?ws=" ws)
        route-str (str js/window.location.origin path)
        ]
    route-str))


(defn analytics-report-list []
  [:div {:class "table-responsive"}
   (let [
        ;;  tier (:tier @globals/jwt-payload)
         env (:env @globals/jwt-payload)
         data (re-frame/subscribe [::analytics-subs/data])
         frow (first @data)
         ks (keys frow)]
     (cond (not-empty @data)
           [:table {:class "table table-striped table-hover"}
            [:thead
             [:tr
              [:th {:scope "col"} "#"]
              (for [k ks]
                [:th {:key k :scope "col"} k])
              (when (= env "prod")
                [:th {:scope "col"} "Admin"])]]
            [:tbody
             (for [[index d] (map-indexed vector @data)]
               [:tr {:key (str ks index)}
                [:td {:scope "row"} [:strong (+ index 1)]]
                (for [k ks]
                  [:td {:key (k d)
                        :style {:max-width "300px"
                                :word-wrap "break-word"
                                :white-space "normal"}}
                   (if (= k :PageLocation)
                     [:a {:href (k d)
                          :target "_blank"} (k d)]
                     (k d))])
                (when (= env "prod")
                  [:td [:a {:class "btn btn-default"
                          ;;  :on-click (fn [e] (on-click-admin e d))
                            :href (get-admin-url d)}
                        [:span {:class "glyphicon glyphicon-pencil"}]]])])]]
           :else
           [:div {:class "text-center"} "No results found"]))])


(defn analytics-report-btns []
  (let [report @(re-frame/subscribe [::analytics-subs/report])]
    [:div {:style {:margin "20px 0 10px"}}
     [:div.btn-group.btn-group-sm
      {:role "group"
       :style {:margin "5px"}}
      [:button.btn {:class (if (= report "realtime") "btn-primary" "btn-default")
                    :on-click (fn [e] (set-report e "realtime"))} "Realtime"]
      [:button.btn {:class (if (= report "realtimeboard") "btn-primary" "btn-default")
                    :on-click (fn [e] (set-report e "realtimeboard"))} "Realtime Board"]]
     [:div.btn-group.btn-group-sm
      {:role "group"
       :style {:margin "5px"}}
      [:button.btn {:class (if (= report "yesterday") "btn-primary" "btn-default")
                    :on-click (fn [e] (set-report e "yesterday"))} "Yesterday"]
      [:button.btn {:class (if (= report "yesterdayboard") "btn-primary" "btn-default")
                    :on-click (fn [e] (set-report e "yesterdayboard"))} "Yesterday Board"]]
      [:div.btn-group.btn-group-sm
       {:role "group"
        :style {:margin "5px"}}
       [:button.btn {:class (if (= report "last24hr") "btn-primary" "btn-default")
                     :on-click (fn [e] (set-report e "last24hr"))} "Last 24hr"]
       [:button.btn {:class (if (= report "last24hrboard") "btn-primary" "btn-default")
                     :on-click (fn [e] (set-report e "last24hrboard"))} "Last 24hr Board"]]
     [:div.btn-group.btn-group-sm
      {:role "group"
       :style {:margin "5px"}}
      [:button.btn {:class (if (= report "archive") "btn-primary" "btn-default")
                    :on-click (fn [e] (set-report e "archive"))} "Archive"]]


     [:div.btn-group.btn-group-sm
      {:role "group"
       :style {:margin "5px"}}
      [:button.btn {:class "btn-default btn-success"
                    :on-click (fn [e] (load-reports e))}
       [:span {:class "glyphicon glyphicon-refresh"}]
       [:span {:class
              ;;  (<class $general/refresh-btn-label)
               "global-refresh-btn-label"
               } " Refresh"]]]]))


(defn set-ws [e ws]
  (.preventDefault e)
  ;; (re-frame/dispatch [::analytics-events/set-ws ws])
  (re-frame/dispatch [::events/set-ws ws])
  )


(defn analytics-ws-btns []
  (let [
        ;; ws @(re-frame/subscribe [::analytics-subs/ws])
        ws @(re-frame/subscribe [::subs/ws])
        ]
    [:div.btn-group.btn-group-sm
     {:role "group"
      :style {:margin "5px 0 20px"}}
     [:button.btn {:on-click (fn [e] (set-ws e "TLO"))
                   :class (if (= ws "TLO") "btn-primary" "btn-default")} "TLO"]
     [:button.btn {:on-click (fn [e] (set-ws e "TSC"))
                   :class (if (= ws "TSC") "btn-primary" "btn-default")} "TSC"]
     [:button.btn {:on-click (fn [e] (set-ws e "STK"))
                   :class (if (= ws "STK") "btn-primary" "btn-default")} "STK"]]))


;; TODO
;; add button that takes you to Iris - this way don't have to parse the string
;; (println (cemerick.url/url "https://www.thelayoff.com/t/1nmza5PH"))

(defn get-progress-bar-class [dc]
  (cond (= dc "mobile") "progress-bar-success"
        (= dc "desktop") "progress-bar-danger"
        (= dc "tablet") ""
        :else ""))


(defn total-report []
  (let [data (re-frame/subscribe [::analytics-subs/total])
        total (reduce (fn [c d] (+ c (:Users d))) 0 @data)
        data-sorted (sort-by :Users #(compare %2 %1) @data)
        ;; take original data, calculate percent (pc) for each item,
        ;; add to total percentage (tpc) of each item by taking previous item and adding new pc to it,
        ;; if it it goes over 100, say pc is 2 and tpc is 101, correct it (npc) (+ (- 100 101) 2)
        ;; works if it is less too, say 99, (+ (- 100 99) 2)
        data-reduced (reduce (fn [state d]
                               (let [pc (js/Math.round (* (/ (:Users d) total) 100))
                                     tpc (or (:tpc (last state)) 0)
                                     ntpc (+ tpc pc)
                                     npc (if
                                          (and (not= ntpc 100)
                                               (= (count data-sorted) (+ (count state) 1)))
                                           (do
                                            ;;  (println "CORRECTING!!")
                                             (+ (- 100 ntpc) pc))
                                           pc)
                                     nd (-> d
                                            (assoc :pc npc)
                                            (assoc :tpc ntpc))]
                                 (conj state nd))) [] data-sorted)]
    [:div.row {:style {:background "whitesmoke"
                       :border "1px solid navajowhite"
                       :margin "0 0 20px 0"}}
     [:div.col-sm-3
      [:div.text-center
       [:div {:style {:font-size "2rem"}} "In last 5 minutes"]
       [:div {:style {:font-size "4rem" :font-weight "bold"}} total]
       [:div "active users on site"]]]
     [:div.col-sm-9
      [:ul.device {:style {:margin-top "55px"
                           :margin-bottom "5px"}}
       (for [d data-sorted]
         [:li {:key (str (:DeviceCategory d) (:Users d)) :class (:DeviceCategory d)} (str (:Users d) " " (string/capitalize (:DeviceCategory d)))])]
      [:div
       {:class "progress" :style {:margin-bottom "10px"}}
       (for [d data-reduced]
         [:div
          {:key (str (:DeviceCategory d) (:pc d))
           :class (str "progress-bar" " " (get-progress-bar-class (:DeviceCategory d)))
           :style {:width (str (:pc d) "%")}}
          [:span (str (:pc d) "%")]])]]]))


(defn analytics-archive-table-selector []
  (let [ws @(re-frame/subscribe [::subs/ws])
        report @(re-frame/subscribe [::analytics-subs/report])
        tables @(re-frame/subscribe [::analytics-subs/tables])]
    (when (= report "archive")
      [:div {:style {:text-align "center" :margin "30px"}}
       [:label {:for "archive-select"} "Select Archive to load data:"]
       [:select {:name "archive-select"
                 :id "archive-select"
                 :class "form-control"
                 :style {:display "inline-block" :width "auto"}
                 :on-change (fn [e]
                              (let [id (.. e -target -value)]
                                (when-not (= id "Archives")
                                  (re-frame/dispatch [::analytics-events/get-analytics-report "archive" ws id]))))}
        [:option "Archives"]
        (for [t tables]
          (let [id (:Id t)
                y (subs id 0 4)
                m (subs id 4 6)
                d (subs id 6 8)]
            [:option {:key (str ws "-" id) :value id} (str y "-" m "-" d)]))]])))


(defn analytics-tabs [tab]
  [:div.btn-group.btn-group-sm
   {:role "group"
    :style {:margin "5px 0 5px"}}
   [:a.btn {:href "/analytics"
            :class (if (= tab "users") "btn-primary" "btn-default")} "Users"]
   [:a.btn {:href "/analytics/page-views"
            :class (if (= tab "views") "btn-primary" "btn-default")} "Views"]])

(defn analytics-report []
  [:<>
   [common/admin-top-bar]
   [common/navbar]
   [:div.container
    [common/spinner]
    [:div {:class "text-center"}
     [analytics-tabs "users"]]
    [:h2.text-center "Active Users Analytics"]
    [:div {:class "row text-center"}
     [analytics-report-btns]]
    [:div {:class "text-center"}
     [analytics-ws-btns]]
    [total-report]
    [analytics-archive-table-selector]
    [analytics-report-list]]
   [common/message ::subs/message]])


(defn analytics-page-views-panel []
  [:<>
   [common/admin-top-bar]
   [common/navbar]
   [:div
    [common/spinner]
    [:div {:class "text-center"}
     [analytics-tabs "views"]]
    [:h2.text-center {:style {:margin-bottom "20px"}} "Page Views Analytics"]
    [:div {:class "text-center"}
     [analytics-ws-btns]]
    [page-views-report]]
   [common/message ::subs/message]])


(defn analytics-panel []
  (load-reports)
  [analytics-report])


